import 'whatwg-fetch';
import { stringify } from 'qs';
import { varsFromServer } from 'client/javascript/client_side_injection_vars';
import { logError } from 'client/javascript/util/logger';
import User, { USER_STORAGE_KEY_MAP } from 'shared/storage/user';
import { getStartDateFilter, formatStartDateForIQS } from 'shared/util/date';
import { getFormattedMoveInDate } from './default_leads_form_data';

function getAvailabilityOrTimeout(availabilityApiUrl) {
  return new Promise((resolve, reject) => {
    let result;

    const timeout = setTimeout(() => {
      if (!result) reject('Availability timeout'); // eslint-disable-line prefer-promise-reject-errors
    }, 3000);

    result = fetch(availabilityApiUrl);
    clearTimeout(timeout);
    resolve(result);
  });
}

export async function getBuildingAvailability(formValues, building) {
  const qsStringifyOptions = {
    encodeValuesOnly: true,
    arrayFormat: 'brackets'
  };
  const { desiredCapacity, move_in_date: moveInDate } = formValues;
  const defaultDate = formatStartDateForIQS(getStartDateFilter());
  const date = getFormattedMoveInDate(
    moveInDate || defaultDate || User.getValue(USER_STORAGE_KEY_MAP.reservableMoveInDate, moveInDate)
  );
  const query = stringify(
    { min_capacity: desiredCapacity, start_date: date, b_ids: [building.id] },
    qsStringifyOptions
  );
  const { apiProxyUrl } = varsFromServer;
  const availabilityApiUrl = `${apiProxyUrl}/iqs/v1/inventory?${query}`;
  const result = await getAvailabilityOrTimeout(availabilityApiUrl);
  const availableOptions = await result.json();

  return availableOptions[building.id] || {};
}

export async function getReservableAvailability(reservableId) {
  try {
    const { apiProxyUrl } = varsFromServer;
    const availabilityApiUrl = `${apiProxyUrl}/iqs/v1/inventory/${reservableId}`;
    const result = await getAvailabilityOrTimeout(availabilityApiUrl);
    const temp = await result.json();
    const reservable = temp.inventory[0];

    return reservable.available && !reservable.onHold && !reservable.paperworkPending;
  } catch (e) {
    logError(`Failed call to getReservableAvailability for reservable: ${reservableId}`, e);
    return false;
  }
}

export async function isAvailable(formValues, building) {
  const products = await getBuildingAvailability(formValues, building);
  return Object.values(products).some((product) => product.available);
}
